import { render, staticRenderFns } from "./UploadDocumentsManagerJSON.vue?vue&type=template&id=b8ca588a&"
import script from "./UploadDocumentsManagerJSON.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentsManagerJSON.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports